<template>
  <AppHeader />

  <main>
    <RouterView />
  </main>

  <AppFooter />

  <TransitionGroup name="slide-fade">
    <AppToast
      v-for="toast in toastStore.toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      @dismissed="toastStore.remove(toast.id)"
    />
  </TransitionGroup>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { watch } from 'vue';

import { usePageTitleStore, useToastStore } from '@/store';
import { AppToast } from '@/components/app';
import { AppFooter, AppHeader } from '@/components/app';

const pageTitleStore = usePageTitleStore();
const toastStore = useToastStore();

const { pageTitle } = storeToRefs(pageTitleStore);

watch(
  pageTitle,
  () => {
    document.title = pageTitle.value;
  }, { immediate: true },
);

</script>
